import { forwardRef } from 'react';
import { Button, Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useEvents } from './useEvents';
import useStyles from './useStyles';

export const AssetActionsOnboardingHint = forwardRef(
  ({ className, style, onNextClick, dontShowAgain, onDontShowAgainChange }, ref) => {
    const styles = useStyles();
    const events = useEvents();

    const handleClose = () => {
      events.trackCloseClick();
      events.trackDontShowAgainChecked(dontShowAgain);
      onNextClick();
    };

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
        style={style}
      >
        <Typography className={styles.title}>
          Start by generating or adding copy to your campaign
        </Typography>

        <div className={styles.actionButtons}>
          <FormControlLabel
            className={styles.showToggle}
            control={<Checkbox color="primary" />}
            label="Don't show again"
            checked={dontShowAgain}
            onChange={onDontShowAgainChange}
          />

          <Button
            className={styles.closeButton}
            color="primary"
            variant="contained"
            onClick={handleClose}
            data-testid="closeButton"
          >
            Close
          </Button>
        </div>
      </div>
    );
  }
);

AssetActionsOnboardingHint.propTypes = {
  className: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
  dontShowAgain: PropTypes.bool,
  onDontShowAgainChange: PropTypes.func.isRequired,
};

AssetActionsOnboardingHint.defaultProps = {
  className: null,
  dontShowAgain: false,
};
